import React, { useState } from "react";
import {Box,Button,Dialog,DialogContent,DialogTitle,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Typography,IconButton,Paper,Divider} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import BaPdf from "../../Images/BA.pdf";
import Backendpdf from "../../Images/Backend.pdf";
import Fepdf from "../../Images/FE.pdf";
import Managerpdf from "../../Images/Manager.pdf";
import Testerpdf from "../../Images/Tester.pdf";
const documents = [
  { name: "Manager", file: Managerpdf, type: "pdf" },
    { name: "Business Analyst", file: BaPdf, type: "pdf" },
    { name: "Backend Developer", file: Backendpdf, type: "pdf" },
    { name: "Frontend Developer", file: Fepdf, type: "pdf" },
    { name: "Tester", file: Testerpdf, type: "pdf" },
];


const SampleInputs = () => {
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const handleOpenDialog = (doc) => {
        setSelectedDoc(doc);
        setOpenDialog(true);
    };

    return (
        <Box 
            sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                height: "100vh", 
                width: "100vw"
            }}
            >
  <Box sx={{ width: "80%", padding: 3, borderRadius: 2}}>
    <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
      Document Management
    </Typography>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            <TableCell><b>Designation</b></TableCell>
            <TableCell><b>Document</b></TableCell>
            <TableCell><b>Actions</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.map((doc, index) => (
            <TableRow key={index}>
              <TableCell>
                <b>{doc.name}</b>
              </TableCell>
              <TableCell>
                <Button
                  startIcon={<VisibilityIcon />}
                  onClick={() => handleOpenDialog(doc)}
                  sx={{ ml: 2 }}
                  variant="outlined"
                >
                  View
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<DownloadIcon />}
                  href={doc.file}
                  download={`${doc.name.replace(/\s+/g, '')}sampleinput.pdf`} 
                >
                  Download
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="xl" fullWidth>
                <DialogTitle sx={{mb:1}}>
                    {selectedDoc?.name}
                    <IconButton onClick={() => setOpenDialog(false)} sx={{ position: "absolute", right: 10, top: 10 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent>
                    <iframe
                        src={selectedDoc?.file}
                        width="100%"
                        height={window.innerHeight * 0.7}
                        title={selectedDoc?.name}
                        style={{ border: "none" }}
                    ></iframe>
                </DialogContent>

            </Dialog>
</Box>

    );
};

export default SampleInputs;
